const phoneKeyPattern = /(mbn|mobile|phone|tel|contact|ct1|ct2|ctn|con|ccn|gcn|spc|kco|guardiancontact|spousecontact)$/i;

export const normalizePhoneValue = (value: any): any => {
  if (typeof value !== 'string') return value;
  const digits = value.replace(/[^\d]/g, '');
  return digits;
};

export const normalizePhonePayload = (payload: any): any => {
  if (Array.isArray(payload)) {
    return payload.map((item) => normalizePhonePayload(item));
  }
  if (!payload || typeof payload !== 'object') return payload;

  const out: any = {};
  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (typeof value === 'string' && phoneKeyPattern.test(key)) {
      out[key] = normalizePhoneValue(value);
    } else if (value && typeof value === 'object') {
      out[key] = normalizePhonePayload(value);
    } else {
      out[key] = value;
    }
  });
  return out;
};

export default normalizePhonePayload;
